import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Opensource delight",
  "description": "",
  "published": "2008-01-16T00:00:00.000Z",
  "redirect_from": ["/blog/opensource-delight/swizec/134"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know why I love working on open source programming? It's not because the model in itself is a wonder or even that good, frankly it has many problems, but that's not what we're here to discuss. It's not even because I love giving back to the community. The reasons are completely and totally vain and because, well, it's easier to do open source than closed source.`}</p>
    <p>{`One thing about open source is that every now and then I get an e-mail from a developer that so loved a function or two of mine that they felt like they should tell me about how much it helped them. And sometimes, just sometimes, something far better happens.`}</p>
    <p>{`Today I received this:`}</p>
    <p>{`Hi Swizec,`}</p>
    <p>{`Just wanted to say – great function!`}</p>
    <p>{`I couldn’t work out why it was working until I littered it with traces and realised that because directories are listed last (I'd never thought to look), there's no recursion issues, as the files are already disposed of.`}</p>
    <p>{`That's a neat trick to take advantage of!`}</p>
    <p>{`Cheers,`}</p>
    <p>{`Dave`}</p>
    <p>{`And at first I even thought he was right, wow, he found out something about my own code I did not know. But a moment later it hit me and I explained to him his error and that the reason said function works is that it first goes into the directory and removes it after it's empty. Neat trick, not too obvious apparently. His next response was also quite a delight:`}</p>
    <p>{`Hey Swizec.`}</p>
    <p>{`You're right. You're right!`}<br parentName="p"></br>{`
`}{`I do lots and lots of recursion for all sorts of things, but in my head this`}<br parentName="p"></br>{`
`}{`definitely seemed more complicated, as the removal of directories demands`}<br parentName="p"></br>{`
`}{`you start from the "outside in" rather than the "inside out". But as you've proved, doing the branches first is the workaround.`}<br parentName="p"></br>{`
`}{`It's great being wrong! A little humbling (which I admit, I'm not THAT keen`}<br parentName="p"></br>{`
`}{`on!) but you get to learn something new.`}<br parentName="p"></br>{`
`}{`Thanks for the workout!`}<br parentName="p"></br>{`
`}{`Cheers,`}<br parentName="p"></br>{`
`}{`Dave`}</p>
    <p>{`We were talking about `}<a parentName="p" {...{
        "href": "http://si.php.net/manual/en/function.rmdir.php#76806"
      }}>{`this`}</a>{` function by the way.`}</p>
    <p>{`So thank you Dave Stewart, whoever you are, for making my day.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      